module.exports = "/images/warning.png?6dbf5a1e3acc6b5eca5a8ee01de24e43";